/**
 * Validates if a matrixdynamic question has duplicate rows.
 * @param params - Array where:
 *   - params[0] is the question's value (array of row objects)
 *   - params[1..n] are column names to ignore in the comparison
 * @returns number of duplicated rows
 */
export const numberOfDuplicatedRowsInMatrix = (params: any) => {
  // First param is the question's value (array of rows)
  const rows = params[0];

  // If no rows or empty array, no duplicates
  if (!rows || !Array.isArray(rows) || rows.length === 0) {
    return 0;
  }

  // Get column names to ignore from remaining params
  const columnsToIgnore = params
    .slice(1)
    .filter((col: any) => typeof col === "string");

  // Create a Set to track seen row signatures
  const seenRows = new Set<string>();
  let numberOfDuplicatedRows = 0;
  // Check each row for duplicates
  for (const row of rows) {
    if (!row || typeof row !== "object") {
      continue;
    }

    // Create a signature for this row by excluding ignored columns
    const rowSignature = Object.keys(row)
      .filter((key) => !columnsToIgnore.includes(key))
      .sort() // Sort keys for consistent comparison
      .map((key) => `${key}:${JSON.stringify(row[key])}`)
      .join("|");

    // If we've seen this signature before, we have a duplicate
    if (seenRows.has(rowSignature)) {
      numberOfDuplicatedRows++;
    }

    // Add this signature to the set
    seenRows.add(rowSignature);
  }

  return numberOfDuplicatedRows;
};
